<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="550px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <el-form ref="form" :model="form" label-width="100px" :rules="rules">
          <!-- 代金券名称 -->
          <el-form-item label="代金券名称" prop="voucherId">
            <el-select
              v-model="form.voucherId"
              placeholder="请输入代金券名称"
              filterable
              remote
              reserve-keyword
              :remote-method="remoteMethod"
              :loading="loading"
              clearable
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 发放方式（单个发放，批量发放） -->
          <el-form-item label="发放方式" prop="sendType">
            <el-radio-group v-model="form.sendType">
              <el-radio label="0">单个发放</el-radio>
              <el-radio label="1">批量发放</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 单个发放 -->
          <el-form-item
            label="发放对象"
            prop="shopId"
            v-if="form.sendType === '0'"
          >
            <el-select
              v-model="form.shopId"
              remote
              placeholder="请输入客户名称"
              style="width: 400px"
              filterable
              reserve-keyword
              :remote-method="remoteMethodForMerchant"
              :loading="loadingForMerchant"
              clearable
            >
              <el-option
                v-for="item in optionsForMerchant"
                :key="item.id"
                :label="`${item.provinceName || ''}/${item.cityName || ''}/${
                  item.areaName || ''
                }/${item.shopName}`"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- 一级范围（按区域，按类型） -->
          <el-form-item
            label="一级范围"
            prop="scopeType"
            v-if="form.sendType === '1'"
          >
            <el-radio-group v-model="form.scopeType">
              <el-radio label="0">按区域</el-radio>
              <el-radio label="1">按类型</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 二级范围 按区域：客户的省市区区域（“审核中心-资质审核-详细地址中的三级行政”），单选下拉选框，可选择到三级中的每一级 ；按类型：按照客户类型发放（“审核中心-资质审核-企业类型”）-->
          <el-form-item
            label="二级范围"
            prop="secondRange"
            v-if="form.sendType === '1'"
          >
            <province-city-area-select
              ref="provinceCityAreaSelectRef"
              v-if="form.scopeType === '0'"
            >
            </province-city-area-select>
            <el-select
              v-model="form.secondRange"
              placeholder="请选择范围"
              v-if="form.scopeType === '1'"
            >
              <el-option
                v-for="item in customerTypeList"
                :key="item.typeCode"
                :label="item.typeName"
                :value="item.typeCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 发券数量 -->
          <el-form-item label="发券数量" prop="sendQty">
            <el-input
              v-model="form.sendQty"
              placeholder="请输入发券数量"
              style="width: 400px"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handlePublish"
          :loading="submitLoading"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getListByType } from "@/api/businessManage";
import provinceCityAreaSelect from "./provinceCityAreaSelect";
import {
  sendVoucher,
  fuzzySearchVoucher,
  fuzzySearchMerchant,
} from "@/api/voucher";
export default {
  name: "voucherAddDlg",
  components: {
    provinceCityAreaSelect,
  },
  props: {
    title: {
      type: String,
      default: "新建",
    },
  },
  data() {
    return {
      visible: false,
      form: {
        sendType: "0",
        scopeType: "",
        secondRange: "",
        sendQty: "",
        voucherId: "",
        shopId: "",
      },
      rules: {
        // 代金券名称长度 20
        voucherId: [
          { required: true, message: "请输入代金券名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        // 发放方式
        sendType: [
          { required: true, message: "请选择发放方式", trigger: "blur" },
        ],
        shopId: [
          { required: true, message: "请选择发放对象", trigger: "blur" },
        ],
        // 一级范围
        scopeType: [
          { required: true, message: "请选择一级范围", trigger: "blur" },
        ],
        // 二级范围
        secondRange: [
          { required: true, message: "请选择二级范围", trigger: "blur" },
        ],
        // 发券数量 1-100 正整数
        sendQty: [
          { required: true, message: "请输入发券数量", trigger: "blur" },
          {
            pattern: /^[1-9]\d*$/,
            message: "单张面额必须为正整数",
            trigger: "blur",
          },
          {
            min: 1,
            max: 2,
            message: "数量必须在 1 到 100 之间",
            trigger: "blur",
          },
        ],
      },
      options: [],
      loading: false,
      optionsForMerchant: [],
      loadingForMerchant: false,
      // 客户类型列表
      customerTypeList: [],
      list: [],
      submitLoading: false,
    };
  },
  created() {
    this.getListByTypeFuc();
  },
  mounted() {},
  watch: {
    "form.scopeType": function (val) {
      this.form.secondRange = "";
      if (val === "0") {
        this.$nextTick(() => {
          this.$refs.provinceCityAreaSelectRef.initData();
        });
      } else {
      }
    },
    // sendType 改变时，也获取一下省市区的数据
    "form.sendType": function (val) {
      if (val === "1") {
        this.$nextTick(() => {
          this.$refs.provinceCityAreaSelectRef.initData();
        });
      }
    },
  },
  methods: {
    publicOpen() {
      this.visible = true;
    },
    submit() {
      this.submitLoading = true;
      let obj = {
        voucherId: this.form.voucherId,
        sendType: this.form.sendType,
        sendQty: this.form.sendQty,
      };
      if (obj.sendType === "0") {
        obj["singleGrant"] = {
          shopId: this.form.shopId,
        };
      } else if (obj.sendType === "1") {
        if (this.form.scopeType === "0") {
          const provinceCityArea = this.form.secondRange.split(",");
          obj["batchGrant"] = {
            scopeType: this.form.scopeType,
            province: provinceCityArea[0],
            city: provinceCityArea[1],
            area: provinceCityArea[2],
          };
        } else if (this.form.scopeType === "1") {
          obj["batchGrant"] = {
            scopeType: this.form.scopeType,
            shopTypeCode: this.form.secondRange,
          };
        }
      }
      sendVoucher(obj)
        .then((res) => {
          if (res) {
            this.$message.success("发放成功");
            this.visible = false;
            this.resetForm();
            this.$emit("refresh");
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.submitLoading = false;
        });
    },
    resetForm() {
      this.form = {
        sendType: "0",
        scopeType: "",
        secondRange: "",
        sendQty: "",
        voucherId: "",
        shopId: "",
      };
    },
    handleValidate() {
      if (this.form.sendType === "1" && this.form.scopeType === "0") {
        const res = this.$refs.provinceCityAreaSelectRef.getData(); //{province: "",city: "",area: ""}
        const provinceCityArea =
          res.province || res.city || res.area
            ? [res.province, res.city, res.area]
            : [];
        this.form.secondRange =
          provinceCityArea && provinceCityArea.length > 0
            ? provinceCityArea.join(",")
            : "";
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    handleClose() {
      this.visible = false;
    },
    handleSave() {
      this.handleValidate();
    },
    handlePublish() {
      this.handleValidate();
    },
    handleUseConditionMoneyFocus() {
      this.form.useCondition = "满金额使用";
    },
    // 获取客户类型列表
    getListByTypeFuc() {
      getListByType({
        type: 0, //商户类型
      }).then((res) => {
        if (res.data) {
          this.customerTypeList = res.data;
        }
      });
    },
    remoteMethod(queryString) {
      let params = {};
      let restaurants = [];
      params.name = queryString;
      // 根据店铺名或手机号搜索店铺
      fuzzySearchVoucher(params)
        .then((res) => {
          if (res) {
            restaurants = res;
            if (queryString !== "") {
              this.options = restaurants;
              this.loading = false;
            } else {
              this.options = [];
              this.loading = false;
            }
          }
        })
        .catch((err) => {});
    },
    remoteMethodForMerchant(queryString) {
      let params = {};
      let restaurants = [];
      params.name = queryString;
      // 根据店铺名或手机号搜索店铺
      fuzzySearchMerchant(params)
        .then((res) => {
          if (res) {
            restaurants = res;
            if (queryString !== "") {
              this.optionsForMerchant = restaurants;
              this.loadingForMerchant = false;
            } else {
              this.optionsForMerchant = [];
              this.loadingForMerchant = false;
            }
          }
        })
        .catch((err) => {});
    },
  },
};
</script>
<style scoped lang="scss"></style>
